import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getKPIDetails(jobId) {
            var meta = { clientApiMethod: 'getKPIDetails', input: { jobId: jobId } }
            var response = await client().get(store.state.apiRouteRoot + "kpi/job/" + jobId, { meta: meta })
            return response?.data;
        },

        async getKPIOptions(jobId) {
            var meta = { clientApiMethod: 'getKPIOptions', input: { jobId: jobId } }
            var response = await client().get(store.state.apiRouteRoot + "KPI/Options/" + jobId, { meta: meta })
            return response?.data;
        },

        async setKPIOptions(dto) {
            var meta = {
                clientApiMethod: 'setKPIOptions',
                input: { dto },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.order.kpi") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "KPI/job", dto, { meta: meta })
            return response?.data;
        },
    }
}
